import { useQuery } from '@tanstack/react-query';
import { UserPeopleDataService } from '../services/UserPeopleDataService';

export const userPeopleQueryKeys = {
  all: ['user-people'] as const,
  inventory: (email: string) => [...userPeopleQueryKeys.all, 'inventory', email] as const,
};

export function useUserPeopleInventoryQuery(email?: string) {
  return useQuery({
    queryKey: userPeopleQueryKeys.inventory(email ?? 'missing'),
    queryFn: () => UserPeopleDataService.getUserPeopleInventory(email!),
    enabled: !!email,
    refetchOnWindowFocus: false,
  });
}